"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const react_hanger_1 = require("react-hanger");
const react_2 = require("@osmosys/react");
exports.ResendInvite = ({ workspace }) => {
    const { state, setState } = react_hanger_1.useSetState({
        showInviteForm: false,
        showSuccess: false,
    });
    return (react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-center" },
        react_1.default.createElement(reactstrap_1.Col, { md: "7", className: "text-center" },
            react_1.default.createElement("hr", null),
            react_1.default.createElement("h3", { className: "my-3" }, "Resend invitation"),
            react_1.default.createElement(reusables_1.Form, { mutationProps: {
                    mutation: graphql_1.createAndInviteUser,
                    onCompleted: () => {
                        setState({
                            showSuccess: true,
                        });
                    },
                }, formikProps: {
                    initialValues: {
                        email: '',
                    },
                    validationSchema: Yup.object().shape({
                        email: Yup.string()
                            .lowercase()
                            .email('Email address is invalid')
                            .required('Required'),
                    }),
                }, valuesToVariables: data => {
                    return {
                        data: {
                            email: (data.email || '').toLowerCase(),
                            isReInvite: true,
                            isWorkspaceAdmin: false,
                            workspaceId: workspace.id,
                        },
                    };
                } }, ({ setFieldValue, setFieldTouched, values, submitForm }, mutationResult) => {
                return (react_1.default.createElement("div", null, state.showSuccess ? (react_1.default.createElement("div", { className: "p-2 text-center" },
                    react_1.default.createElement("p", { className: "lead" },
                        values.email,
                        " invited."),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("a", { href: "#", onClick: e => {
                                e.preventDefault();
                                setState({
                                    showSuccess: false,
                                });
                                setFieldValue('email', '');
                                setFieldTouched('email', false);
                            } }, "Resend another invite.")))) : (react_1.default.createElement("div", { className: "text-left" },
                    react_1.default.createElement(reusables_1.FormGroup, { placeholder: "Email address", label: "Email address", name: "email", type: "email" }),
                    react_1.default.createElement(reusables_1.AjaxButton, { label: "Resend invite", type: "button", loading: mutationResult.loading, success: !!mutationResult.data, error: mutationResult.error, successText: "Resent an invitation to user", onClick: () => {
                            submitForm();
                        } }),
                    react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "UserInvite", action: "create", apolloError: mutationResult.error })))));
            }))));
};
//# sourceMappingURL=ResendInvite.js.map